export const URL_PARAM = {
  START: 'start',
  END: 'end',
  UTC: 'utc',
  PERIOD: 'statsPeriod',
  PROJECT: 'project',
  ENVIRONMENT: 'environment',
};

export const DATE_TIME = {
  START: 'start',
  END: 'end',
  PERIOD: 'period',
  UTC: 'utc',
};

export const DATE_TIME_KEYS = [...Object.values(DATE_TIME), 'statsPeriod'];

export const LOCAL_STORAGE_KEY = 'global-selection';

export const ALL_ACCESS_PROJECTS = -1;
